<template>
<div class="right-bar">
  <el-select
    class="select-mam-el"
    style="width: 100%"
    v-model="mamMaster"
    :placeholder="$t('Search_trader_nickname')"
    filterable
    remote
    reserve-keyword
    :remote-method="getMamMasterOption"
  >
    <div
      class="prefix-out"
      slot="prefix"
    >
      <img
        src="../../../assets/images/icon/search.png"
      />
    </div>

    <el-option
      v-for="(item,index) in mamMasterList"
      :key="index"
      :label="item.label"
      :value="item.value"
      class="select-mam-self-option"
    >
      <div
        @click="mamMasterHandle(item)"
        class="mam-option-inner">
        <div class="alias">{{item.alias || '#' + item.copyLogin}}</div>
        <div class="login">{{item.login}}</div>
      </div>
    </el-option>
  </el-select>
  <recommend-swiper
    :is-border="isBorder"
  ></recommend-swiper>
</div>
</template>

<script>
import { queryTopSignal } from '@/api/userCenter'
import recommendSwiper from "@/components/copyMaster/home/recommendSwiper";
export default {
  name: "rightBar",
  props: {
    isBorder: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    recommendSwiper
  },
  data() {
    return {
      mamMaster: '',
      mamMasterList: [],
    }
  },
  methods: {
    getMamMasterOption(query){
      if (query !== '') {
        queryTopSignal({
          alias: query,
        }).then((res) => {
          console.log(res);
          this.mamMasterList = res.data;
        });
      } else {
        this.mamMasterList = [];
      }
    },
    mamMasterHandle(item){
      localStorage.setItem('goBackRouterName','copyMaster');
      this.$router.push({name: 'mamMasterDetails',params: {mtid: item.mtId}});
    }
  },
}
</script>

<style lang="scss" scoped>
.right-bar {
  .select-mam-el {
    margin-bottom: 20px;
  }
}
.prefix-out {
  line-height: 40px;
  padding-left: 5px;
}
</style>
<style lang="scss">
@import "../../../assets/scss/variable";
.select-mam-self-option {
  height: 50px!important;
  line-height: 12px!important;
  padding-top: 5px;
  .alias {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
  }
  &:hover {
    .alias,
    .login {
      color: $themeColor;
    }
  }
}

</style>
